import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_85a3118wke: FaireBrandEntity = {
  token: "b_85a3118wke",
  type: "brand",
  name: "Le Bon Shoppe",
  avatarUrl:
    "https://cdn.faire.com/fastly/5677c44593e8a459b0b8218e79495b6be38b2c1155b53653a1aa48234b18427b.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/596dc7aeb994efb6f2cddc89e3e5208b0b12da8f58df545c465e9b5e06e16829.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/5677c44593e8a459b0b8218e79495b6be38b2c1155b53653a1aa48234b18427b.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/596dc7aeb994efb6f2cddc89e3e5208b0b12da8f58df545c465e9b5e06e16829.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 300,
  rating: 5,
  reviewCount: 356,
  isTopShop: true,
  isInsider: true,
  description:
    "DEAR FIRST TIME BUYERS: WE ARE NOT ACCEPTING NEW ACCOUNTS AT THE MOMENT. WE ARE CURRENTLY OPERATING AT FULL CAPACITY AND ARE NOT PURSUING EXPANSION AT THIS TIME.\n\n\nThe founders of Le Bon Shoppe met in the fashion industry, and bonded deeply over their mutual love of vintage-hunting, natural textiles, and the road less traveled.\n\nLe Bon Shoppe is inspired by their personal search for the perfect staple items for their own closets.\n\nTheir vision is to create beautiful, stand alone pieces that live beyond the whims of seasons and trends. With a focus on natural textiles, simple designs, and prismatic colors, Le Bon Shoppe is a collection of timeless treasures for you to add to your own trove.",
  meta: {
    source: "api",
    importedAt: "2026-04-21T23:43:07.677Z",
    importedBy: "entity-db-cli",
  },
};
